import { prepareContentWithBase64Images } from '@/utils';
import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatCommonInquiryBoardDetail,
	formatCommonInquiryBoardList,
} from './common-inquiry-board.helper';
import { CommonInquiryBoardActions } from './common-inquiry-board.redux';
import {
	ICreateInquiryBoardRequest,
	IPayloadDeleteCommonInquiryBoardRequest,
	IPayloadGetCommonInquiryBoardDetailRequest,
	IPayloadGetCommonInquiryBoardListRequest,
} from './common-inquiry-board.type';

export function* getCommonInquiryBoardList(
	action: PayloadAction<IPayloadGetCommonInquiryBoardListRequest>
) {
	const { searchTypes, callback, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetCommonInquiryBoardListResponse> =
			yield API.getCommonInquiryBoardList({ searchTypes, ...rest });
		const content = formatCommonInquiryBoardList(res?.data?.content);

		yield put(
			CommonInquiryBoardActions.getCommonInquiryBoardListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(CommonInquiryBoardActions.getCommonInquiryBoardListFailure());
	}
}

export function* getCommonInquiryBoardDetail(
	action: PayloadAction<IPayloadGetCommonInquiryBoardDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.ICommonInquiryBoard> =
			yield API.getCommonInquiryBoardDetail(id);
		const detail = formatCommonInquiryBoardDetail(res.data);

		const contents: string = yield prepareContentWithBase64Images(
			detail?.contents
		);

		yield put(
			CommonInquiryBoardActions.getCommonInquiryBoardDetailSuccess({
				detail: {
					...detail,
					contents,
				},
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(CommonInquiryBoardActions.getCommonInquiryBoardDetailFailure());
	}
}

export function* getCommonInquiryBoardDetailAnswer(
	action: PayloadAction<IPayloadGetCommonInquiryBoardDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.ICommonInquiryBoard> =
			yield API.getCommonInquiryBoardDetailAnswer(id);
		const detail = formatCommonInquiryBoardDetail(res.data);

		yield put(
			CommonInquiryBoardActions.getCommonInquiryBoardDetailAnswerSuccess({
				detail,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			CommonInquiryBoardActions.getCommonInquiryBoardDetailAnswerFailure()
		);
	}
}

export function* createCommonInquiryBoard(
	action: PayloadAction<ICreateInquiryBoardRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		yield API.createCommonInquiryBoard(rest);

		yield put(CommonInquiryBoardActions.createCommonInquiryBoardSuccess());

		callback?.();
	} catch (error: unknown) {
		callback?.(error as API.ApiResponseError);

		yield put(CommonInquiryBoardActions.createCommonInquiryBoardFailure());
	}
}

export function* deleteCommonInquiryBoard(
	action: PayloadAction<IPayloadDeleteCommonInquiryBoardRequest>
) {
	const { ids, callback } = action.payload;

	try {
		yield API.deleteCommonInquiryBoard(ids);

		yield put(CommonInquiryBoardActions.deleteCommonInquiryBoardSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(CommonInquiryBoardActions.deleteCommonInquiryBoardFailure());
	}
}
